import React from 'react';

const ScreenContainer = ({ children, className = '' }) => {
  // Match the exact layout from original create-book
  return (
    <div className={`max-w-[820px] w-full mx-auto px-6 md:px-14 ${className}`}>
      {children}
    </div>
  );
};

export default ScreenContainer;